import React from 'react';
import Spinner from '../Spinner/Spinner';
import '../Spinner/Spinner.css';

const NumberWheel = () => {
  return(
    <div className="spinner-page">
      <Spinner />
    </div>
  );
}
export default NumberWheel;